import { createContext, useContext, useState, useMemo, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import localforage from "localforage";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

// Setting custom name for the context which is visible on react dev tools
AuthContext.displayName = "AuthContext";
function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [authSession, setAuthSession] = useState({});
  const clear = () => {
    const url = `/${authSession.companyId}/sub_accounts`;
    setAuthSession({});
    localforage.removeItem("authSession");
    navigate(url);
  };

  const loginAsSubAccount = (subAccountId, companyId) => {
    setAuthSession({
      activeAccountId: subAccountId,
      companyId: companyId,
      loginAsAdmin: true,
    });

    localforage.setItem("authSession", {
      activeAccountId: subAccountId,
      companyId: companyId,
      loginAsAdmin: true,
    });

    // Redirect to sub-account dashboard
    navigate(`/account/${companyId}/${subAccountId}/users`);
  };

  const value = useMemo(
    () => [authSession, loginAsSubAccount, clear],
    [authSession, loginAsSubAccount, clear]
  );

  const onLoad = async () => {
    const localAuth = await localforage.getItem("authSession");
    if (!localAuth) return;
    setAuthSession({ ...localAuth });
  };

  useEffect(onLoad, []);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

function useAuthInfo() {
  return useContext(AuthContext) || [];
}
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AuthProvider, useAuthInfo };
